import { Component, Input, OnInit, OnChanges, SimpleChanges, ViewChild, ElementRef, AfterViewInit } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-video-player",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./video-player.component.html",
  styleUrl: "./video-player.component.scss",
})
export class VideoPlayerComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() videoUrl: string | null = null;
  @ViewChild("videoElement", { static: false }) videoElementRef!: ElementRef<HTMLVideoElement>;

  videoElement: HTMLVideoElement | null = null;
  isPlaying: boolean = false;
  currentTime: number = 0;
  duration: number = 0;
  progress: number = 0;

  ngOnInit(): void {
    alert("1")
    // Component initialization
  }

  ngAfterViewInit(): void {
    if (this.videoElementRef) {
      this.videoElement = this.videoElementRef.nativeElement;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["videoUrl"] && this.videoElement) {
      this.loadVideo();
    }
  }

  onVideoLoaded(event: Event): void {
    this.videoElement = event.target as HTMLVideoElement;
    if (this.videoElement) {
      this.duration = this.videoElement.duration;
      this.updateProgress();
    }
  }

  loadVideo(): void {
    if (this.videoElement && this.videoUrl) {
      this.videoElement.load();
      this.isPlaying = false;
      this.currentTime = 0;
      this.progress = 0;
    }
  }

  togglePlay(): void {
    if (!this.videoElement) return;

    if (this.isPlaying) {
      this.videoElement.pause();
    } else {
      this.videoElement.play();
    }
    this.isPlaying = !this.isPlaying;
  }

  onTimeUpdate(): void {
    if (this.videoElement) {
      this.currentTime = this.videoElement.currentTime;
      this.updateProgress();
    }
  }

  onPlay(): void {
    this.isPlaying = true;
  }

  onPause(): void {
    this.isPlaying = false;
  }

  updateProgress(): void {
    if (this.duration > 0) {
      this.progress = (this.currentTime / this.duration) * 100;
    }
  }

  formatTime(seconds: number): string {
    if (!seconds || isNaN(seconds)) return "00:00";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  }

  seek(event: MouseEvent): void {
    if (!this.videoElement || !this.duration) return;
    const progressBar = event.currentTarget as HTMLElement;
    const rect = progressBar.getBoundingClientRect();
    const clickX = event.clientX - rect.left;
    const percentage = clickX / rect.width;
    const newTime = percentage * this.duration;
    this.videoElement.currentTime = newTime;
    this.currentTime = newTime;
    this.updateProgress();
  }
}

